const matchPath = (template: string, pathname: string): boolean => {
  const templateSegments = template.split('/').filter(Boolean);
  const pathSegments = pathname.split('/').filter(Boolean);

  if (templateSegments.length !== pathSegments.length) {
    return false;
  }

  return templateSegments.every((segment, index) => {
    if (segment.startsWith(':')) {
      return true;
    }
    return segment === pathSegments[index];
  });
};

export default matchPath;
